import React from 'react';
import PropTypes from 'prop-types';
import { testId as testid } from 'ui-components/services/testid-service';

import style from './page.module.less';

const Page = ({ children, testId = 'page' }) => {
  return (
    <div className={style.page} {...testid(testId)}>
      {children}
    </div>
  );
};

Page.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
};

export default Page;
